// extracted by mini-css-extract-plugin
module.exports = {"btnContainer":"ClientSideButton_btnContainer__kilP_","btnText":"ClientSideButton_btnText__5gMgu"};